import React, { useState, useRef, useEffect } from "react";
import { MapContainer, TileLayer, Marker, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./MapComponent.css"; 
import pakistanGeoJSON from "./pakistan.json"; 
import Navbar from './Navbar';

// Default marker icon settings
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const blinkingIcon = new L.Icon({
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  className: "blinking-icon",
});

const defaultIcon = new L.Icon({
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const Find = () => {
   
  const [activeCityIndex, setActiveCityIndex] = useState(-1);
  const [zoomLevel, setZoomLevel] = useState(6);
  const observerRef = useRef();

  const cities = [
    { name: "Islamabad", position: [33.6844, 73.0479] },
    { name: "Lahore", position: [31.5497, 74.3436] },
    { name: "Karachi", position: [24.8607, 67.0011] },
    { name: "Faisalabad", position: [31.4504, 73.135] },
    { name: "Rawalpindi", position: [33.5651, 73.0169] },
    { name: "Peshawar", position: [34.0151, 71.5249] },
    { name: "Abbottabad", position: [34.1696, 73.2215] },
    { name: "Mansehra", position: [34.3333, 73.2] },
    { name: "Murree", position: [33.9066, 73.3901] },
    { name: "Gujranwala", position: [32.1877, 74.1945] },
    { name: "Jhelum", position: [32.9333, 73.7333] },
    { name: "Sialkot", position: [32.4927, 74.5319] },
    { name: "Sambaryal", position: [32.5833, 74.3667] },
    { name: "Sheikhupura", position: [31.7131, 73.9783] },
    { name: "Shahkot", position: [31.5703, 73.4895] },
    { name: "Sargodha", position: [32.0836, 72.671] },
    { name: "Sahiwal", position: [30.6769, 73.1064] },
    { name: "Borewala", position: [30.1671, 72.6896] },
    { name: "Chicha Watani", position: [30.5333, 72.6833] },
    { name: "Toba Tek Singh", position: [30.9743, 72.4827] },
    { name: "Jhang", position: [31.2681, 72.3171] },
    { name: "Layyah", position: [30.9613, 70.939] },
    { name: "Multan", position: [30.1575, 71.5249] },
    { name: "Bahawalpur", position: [29.3544, 71.6911] },
    { name: "Rahim Yar Khan", position: [28.3922, 70.3186] },
    { name: "Chowk Munda", position: [29.7276, 70.3787] },
  ];

  const createCityNameIcon = (cityName) => {
    return L.divIcon({
      html: `<div style="font-size: 1.2rem; color: gold; width:8rem; background-color:#23232a; padding-left:0.4vw">${cityName}</div>`,
      iconAnchor: [12, 100],
      className: "city-name-icon",
    });
  };

  const startCitySequence = () => {
    cities.forEach((_, index) => {
      setTimeout(() => {
        setActiveCityIndex(index);
      }, index * 5000);
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startCitySequence();
        }
      },
      { threshold: 0.3 }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observer.unobserve(observerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const updateZoomLevel = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 660) {
        setZoomLevel(4);
      } else if (screenWidth <= 1466) {
        setZoomLevel(5.0);
      } else if (screenWidth > 1466) {
        setZoomLevel(7);
      } else {
        setZoomLevel(8);
      }
    };

    updateZoomLevel();
    window.addEventListener("resize", updateZoomLevel);
    return () => window.removeEventListener("resize", updateZoomLevel);
  }, []);
 
  return (
    <>
      <Navbar isHome={false} />
      <div className="map" ref={observerRef} id="pakistan-map">
        <h1 className="map-heading">قریہ قریہ ہم اور آپ</h1>
        <MapContainer
          center={[31.0753, 68.644]}
          zoom={zoomLevel}
          style={{ height: "100%", width: "100%" }}
          scrollWheelZoom={false}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          <GeoJSON
            data={pakistanGeoJSON}
            style={{ color: "green", weight: 2, fillOpacity: 1 }}
          />
          {cities.map((city, index) => (
            <React.Fragment key={city.name}>
              <Marker
                position={city.position}
                icon={activeCityIndex === index ? blinkingIcon : defaultIcon}
              />
              {activeCityIndex === index && (
                <Marker
                  position={city.position}
                  icon={createCityNameIcon(city.name)}
                />
              )}
            </React.Fragment>
          ))}
        </MapContainer>
      </div>
    </>
  );
};

export default Find;
